import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/users/$userId")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/users",
      search: { userId: params.userId },
    });
  },
});
